/* =============================================================================
   Freedom Sale hero — "cable chakra" art (design 2a)
   -----------------------------------------------------------------------------
   Draws the tricolor in flat MagLock cable: two wavy bands top and bottom, and
   an Ashoka chakra that is really one cable coiled into a spiral. Tapping the
   card animates the spiral out into a straight run of cable and back.

   Ported from the Claude Design prototype's canvas logic. Everything is drawn
   into an inline SVG at a fixed 760x540 viewBox and scaled by CSS, so the art is
   resolution-independent and needs no image asset.

   Motion gates, in the theme's house rule: the merchant's "Chakra animation"
   setting is the switch. The OS "Reduce Motion" preference is only honoured when
   the merchant leaves "Play even with Reduce Motion on" OFF — the owner's own
   device runs Reduce Motion, so a silent CSS-level kill reads as a broken build.
   ============================================================================= */
(function () {
  if (window.__fsHeroBound) { return; }
  window.__fsHeroBound = true;

  var SVGNS = 'http://www.w3.org/2000/svg';
  var uid = 0;

  function el(name, attrs, parent) {
    var e = document.createElementNS(SVGNS, name);
    for (var k in attrs) { e.setAttribute(k, attrs[k]); }
    if (parent) { parent.appendChild(e); }
    return e;
  }

  function Chakra(root) {
    this.root = root;
    this.host = root.querySelector('[data-fsh-art]');
    this.hint = root.querySelector('[data-fsh-hint]');
    this.id = 'fsh' + (++uid);
    this.N = 420;
    this.coiled = true;
    this.u = 1; this.uFrom = 1; this.uTarget = 1;
    this.phi = -Math.PI / 2;
    this.animT0 = 0; this.rippleT0 = -1e9; this.last = 0; this.bandsDirty = false;

    this.animate = root.dataset.fshAnim === '1';
    var force = root.dataset.fshForce === '1';
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* The merchant's toggle is the gate; Reduce Motion only wins when he has not
       asked the effect to play through it. */
    this.reduced = !force && reduced;

    this.hintCoiled = root.dataset.fshHint1 || 'Tap the chakra';
    this.hintOpen = root.dataset.fshHint2 || 'Tap to snap it back';

    this.colors = {
      saffron: root.dataset.fshSaffron || '#e97817',
      green: root.dataset.fshGreen || '#0f7a3a',
      chakra: root.dataset.fshChakra || '#20265a'
    };

    this.build();
    if (this.animate) {
      root.addEventListener('click', this.toggle.bind(this));
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.toggle(); }
      }.bind(this));
    }
    this.loop();
  }

  /* A darker companion for each cable's edge, so the art keeps its depth when the
     merchant recolours it. Falls back to the colour itself if parsing fails. */
  Chakra.prototype.shade = function (hex, k) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!m) { return hex; }
    var out = '#';
    for (var i = 1; i <= 3; i++) {
      var v = Math.max(0, Math.round(parseInt(m[i], 16) * k));
      out += ('0' + v.toString(16)).slice(-2);
    }
    return out;
  };

  Chakra.prototype.build = function () {
    if (!this.host || this.host.__built) { return; }
    this.host.__built = true;

    var svg = el('svg', {
      viewBox: '0 0 760 540',
      'aria-hidden': 'true',
      style: 'position:absolute;inset:0;width:100%;height:100%;display:block;'
    });
    this.host.appendChild(svg);

    var defs = el('defs', {}, svg);
    var g = el('linearGradient', { id: this.id + 'metal', x1: '0', y1: '0', x2: '0', y2: '1' }, defs);
    el('stop', { offset: '0', 'stop-color': '#9aa0aa' }, g);
    el('stop', { offset: '0.5', 'stop-color': '#767c88' }, g);
    el('stop', { offset: '1', 'stop-color': '#565c66' }, g);
    var blur = el('filter', { id: this.id + 'blur', x: '-80%', y: '-80%', width: '260%', height: '260%' }, defs);
    el('feGaussianBlur', { stdDeviation: '10' }, blur);

    this.coilShadow = el('ellipse', {
      cx: 380, cy: 392, rx: 96, ry: 13, fill: 'rgb(26 26 26)', opacity: 0.14,
      filter: 'url(#' + this.id + 'blur)'
    }, svg);

    this.saffron = this.cable(svg, this.colors.saffron, 24);
    this.green = this.cable(svg, this.colors.green, 24);
    this.navy = this.cable(svg, this.colors.chakra, 14);

    this.drawBands(0);
    this.drawChakra();
  };

  Chakra.prototype.cable = function (svg, color, w) {
    var grp = el('g', {}, svg);
    var mk = function (stroke, width, dash) {
      var p = el('path', {
        fill: 'none', stroke: stroke, 'stroke-width': width,
        'stroke-linecap': 'round', 'stroke-linejoin': 'round'
      }, grp);
      if (dash) { p.setAttribute('stroke-dasharray', dash); p.setAttribute('stroke-linecap', 'butt'); }
      return p;
    };
    return {
      edgeP: mk(this.shade(color, 0.72), w + 4.5),
      mainP: mk(color, w),
      /* the woven texture of the real flat cable */
      braid: mk('rgb(0 0 0 / .15)', w * 0.88, '2.6 5.2'),
      sheen: mk('rgb(255 255 255 / .4)', Math.max(2, w * 0.2)),
      cA: this.connector(grp, w),
      cB: this.connector(grp, w)
    };
  };

  /* The USB head at each end of a cable run. */
  Chakra.prototype.connector = function (parent, w) {
    var g = el('g', {}, parent);
    var h = w + 2;
    el('rect', { x: -2, y: -h * 0.42, width: 13, height: h * 0.84, rx: 3, fill: '#2b2b2e' }, g);
    el('rect', { x: 10, y: -(h + 8) / 2, width: h * 1.55, height: h + 8, rx: 6, fill: 'url(#' + this.id + 'metal)' }, g);
    el('rect', { x: 10 + h * 1.55 - 2, y: -h * 0.32, width: h * 0.72, height: h * 0.64, rx: h * 0.3, fill: '#c3c8d0' }, g);
    return g;
  };

  Chakra.prototype.setCable = function (c, pts) {
    var d = '';
    for (var i = 0; i < pts.length; i++) {
      d += (i ? 'L' : 'M') + pts[i][0].toFixed(1) + ' ' + pts[i][1].toFixed(1);
    }
    c.edgeP.setAttribute('d', d);
    c.mainP.setAttribute('d', d);
    c.braid.setAttribute('d', d);
    c.sheen.setAttribute('d', d);
    this.placeCon(c.cA, pts, false);
    this.placeCon(c.cB, pts, true);
  };

  Chakra.prototype.placeCon = function (g, pts, atEnd) {
    var a = atEnd ? pts[pts.length - 1] : pts[0];
    var b = atEnd ? pts[pts.length - 2] : pts[1];
    var ang = Math.atan2(a[1] - b[1], a[0] - b[0]) * 180 / Math.PI;
    g.setAttribute('transform', 'translate(' + a[0] + ',' + a[1] + ') rotate(' + ang + ')');
  };

  Chakra.prototype.bandPts = function (y, phase, ripple) {
    var pts = [];
    for (var i = 0; i < 90; i++) {
      var s = i / 89, x = 82 + s * (678 - 82);
      pts.push([x, y + 9 * Math.sin(x / 95 + phase) + ripple * 8 * Math.sin(x / 55)]);
    }
    return pts;
  };

  Chakra.prototype.drawBands = function (rip) {
    this.setCable(this.saffron, this.bandPts(92, 0.4, rip));
    this.setCable(this.green, this.bandPts(448, 2.1, -rip));
  };

  /* The spiral. `u` is 1 when fully coiled into the chakra and 0 when the cable
     has been pulled straight; every point is a lerp between those two shapes. */
  Chakra.prototype.chakraPts = function () {
    var N = this.N, pts = [], cx = 380, cy = 270, b = 8.3, thMax = 11.5, halfLen = 300;
    var eu = this.u, phi = this.phi;
    for (var i = 0; i < N; i++) {
      var s = (i / (N - 1)) * 2 - 1;
      var th = Math.abs(s) * thMax, r = b * th;
      var a = th + phi + (s < 0 ? Math.PI : 0);
      var sx = cx + r * Math.cos(a), sy = cy + r * Math.sin(a);
      var lx = cx + s * halfLen;
      var damp = Math.max(0, Math.min(1, (0.94 - Math.abs(s)) / 0.14));
      var ly = cy + 20 * Math.sin(lx / 78) * damp;
      pts.push([lx + (sx - lx) * eu, ly + (sy - ly) * eu]);
    }
    return pts;
  };

  Chakra.prototype.drawChakra = function () { this.setCable(this.navy, this.chakraPts()); };

  Chakra.prototype.ease = function (x) {
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
  };

  Chakra.prototype.toggle = function () {
    if (!this.animate) { return; }
    this.coiled = !this.coiled;
    if (this.hint) { this.hint.textContent = this.coiled ? this.hintCoiled : this.hintOpen; }
    this.root.setAttribute('aria-pressed', this.coiled ? 'false' : 'true');
  };

  Chakra.prototype.frame = function (t) {
    var want = this.coiled ? 1 : 0;
    if (this.uTarget !== want) {
      this.uFrom = this.u; this.uTarget = want; this.animT0 = t; this.rippleT0 = t;
    }
    var dt = Math.min(50, t - (this.last || t));
    this.last = t;

    var animating = this.u !== this.uTarget;
    if (animating) {
      var k = Math.min(1, (t - this.animT0) / 1150);
      this.u = this.uFrom + (this.uTarget - this.uFrom) * this.ease(k);
      if (k >= 1) { this.u = this.uTarget; }
    }

    /* Idle spin: the coiled chakra turns slowly. Suppressed while the cable is
       straight (nothing to turn) and under a respected Reduce Motion. */
    var spin = this.animate && !this.reduced && this.u > 0.001;
    if (spin) { this.phi += dt * 0.00028; }

    var rip = this.animate ? Math.exp(-(t - this.rippleT0) / 420) * Math.sin((t - this.rippleT0) / 68) : 0;
    if (Math.abs(rip) > 0.004) { this.drawBands(rip); this.bandsDirty = true; }
    else if (this.bandsDirty) { this.drawBands(0); this.bandsDirty = false; }

    if (animating || spin) {
      this.drawChakra();
      this.coilShadow.setAttribute('opacity', (0.05 + 0.09 * this.u).toFixed(3));
      this.coilShadow.setAttribute('rx', (96 * this.u + 300 * (1 - this.u)).toFixed(1));
      this.coilShadow.setAttribute('cy', (392 * this.u + 302 * (1 - this.u)).toFixed(1));
      this.coilShadow.setAttribute('ry', (13 * this.u + 8 * (1 - this.u)).toFixed(1));
    }
  };

  Chakra.prototype.loop = function () {
    var self = this;
    var tick = function (t) { self.raf = requestAnimationFrame(tick); self.frame(t); };
    this.raf = requestAnimationFrame(tick);
  };

  function init() {
    var nodes = document.querySelectorAll('[data-fsh]');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].__fsh) { nodes[i].__fsh = new Chakra(nodes[i]); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme editor re-renders the section on every setting change. */
  document.addEventListener('shopify:section:load', init);
})();
